<template>
  <el-dialog
      :visible.sync="visible"
      title="物料收货单"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item label="实际发货时间：" prop="operateDate">
            <el-date-picker
                v-model="dataForm.operateDate"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="选择时间"
                size="mini"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6" >
          <el-form-item  label="发货方：" prop="sellerId">
            <company v-model="dataForm.sellerId" :disabled="$c.str2bool(id)"></company>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="optType===20">
          <el-form-item  label="收货方：" prop="receiverId">
            <company v-model="dataForm.receiverId"></company>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注：" prop="remark" label-width="80px" style="margin-bottom: 0;">
            <el-input
                size="mini"
                v-model="dataForm.remark"
                placeholder="备注"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">

        <el-col :span="12">
          <el-form-item label="凭证照片：" prop="imgs" style="margin-bottom: 0;">
            <MultipleImageUpload v-model="dataForm.imgs"></MultipleImageUpload>
          </el-form-item>
        </el-col>
      </el-row>
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="500">
        <el-table-column label="订单编号" prop="orderCode" align="center">
        </el-table-column>
        <el-table-column label="品番号" v-if="optType===20||optType===30" prop="product.code" align="center">
        </el-table-column>
        <el-table-column label="SKU" v-if="optType===20||optType===30" prop="product.skuCode" align="center">
        </el-table-column>
        <el-table-column label="品名" v-if="optType===20||optType===30" prop="product.name" align="center">
        </el-table-column>
        <el-table-column label="中文品名" v-if="optType===20||optType===30" prop="product.nameZh" align="center">
        </el-table-column>
        <el-table-column label="物料名称" v-if="optType===10" prop="product.name" align="center">
        </el-table-column>
        <el-table-column label="颜色" prop="product.color" align="center">
        </el-table-column>
        <el-table-column label="规格" prop="product.size" align="center">
        </el-table-column>
        <el-table-column label="幅宽" v-if="optType===10" prop="product.attr1" align="center">
        </el-table-column>
        <el-table-column label="克重" v-if="optType===10" prop="product.attr2" align="center">
        </el-table-column>
        <el-table-column label="收货方" prop="receiverName" :show-overflow-tooltip="true" align="center" width="120"
                         :formatter="$c.companyNameFormatter">
        </el-table-column>
        <el-table-column
            label="本次发货数量"
            header-align="center"
            align="center"
            width="120"
        >
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.count'"
                :rules="detailRule.count"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input v-model="scope.row.count" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button @click="visible=false" size="mini">{{ $t('cancel') }}</el-button>
      <el-button type="primary" size="mini" @click="dataFormSubmitHandle">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 发货弹窗
 */
import debounce from 'lodash/debounce'
import MultipleImageUpload from '@/components/MultipleImageUpload'
import { detailRule, dataRule } from './save-dialog-validate'

export default {
  components: { MultipleImageUpload },
  props: {
    optType: {//操作类型,10物料发货,20成品发货,30箱单发货
      type: Number,
      default: null
    }
  },
  data () {
    return {
      id: '',
      visible: false,
      dataForm: {},
      detailRule: detailRule,
      dataRule: dataRule
    }
  },
  computed: {},
  methods: {
    async init (id) {
      this.visible = true
      this.$nextTick(() => {
        this.initForm(id)
      })
    },
    //表单初始化
    async initForm (id) {
      this.id = id
      if (this.id) {
        await this.getInfo()
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate()
        })
      } else {
        this.$refs.dataForm.resetFields()
      }
    },
    //读取表单数据
    async getInfo () {
      let data = await this.$api.get(`/erp/receive/${this.id}`)
      let detailData = await this.$api.get(`/erp/receive/detail/page`, {
        params: {
          page: 1,
          limit: 100000,
          pid: this.id
        }
      })
      data.detailList = detailData.list
      this.dataForm = {
        ...data
      }
    },
    // 表单提交
    dataFormSubmitHandle:
        debounce(
            function (keep) {
              this.$refs['dataForm'].validate((valid) => {
                if (!valid) {
                  return false
                }

                let postForm = this.$clone(this.dataForm)
                postForm.type = this.optType
                if (postForm.detailList.length === 0) {
                  return this.$message.error('请填写明细')
                }
                if (postForm.type === 20) {
                  postForm.detailList.forEach(row => {
                    row.receiverId = postForm.receiverId
                  })
                }
                this.loading = true
                let url=''
                if(this.id){
                  url='/erp/receive/edit'
                }
                this.$api
                    .post(url, postForm)
                    .then(res => {
                      this.loading = false
                      this.$c.success('保存成功').then(() => {
                        this.visible = false
                        this.$emit('change')
                      })
                    })
                    .catch((e) => {
                      this.loading = false
                    })
              })
            },
            1000,
            { leading: true, trailing: false }
        )
  },
}
</script>

<style lang="scss" scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
